<template>
  <el-dialog
    title="编辑上架"
    :visible.sync="editVisible"
    width="40%"
    :before-close="handleClose"
    center
  >
    <!-- 表单 -->
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
    <!--  -->
    <div class="title" style="marginLeft:5px;marginBottom:20px;fontWeight:bold;fontSize:16px">
        商品标题
    </div>
    <el-form-item prop="sub_title" label-width="0">
         <el-input size="small" style="width:100%;" v-model="ruleForm.sub_title" placeholder="请输入商品标题"></el-input>
    </el-form-item>
    <div class="title" style="marginLeft:5px;marginBottom:20px;fontWeight:bold;fontSize:16px">
        直播利益点
    </div>
    <el-form-item prop="hot_live" label-width="0">
         <el-input size="small" type="textarea" style="width:100%;" v-model="ruleForm.hot_live" placeholder="请输入直播利益点"></el-input>
    </el-form-item>
    <div class="title" style="marginLeft:5px;marginBottom:20px;fontWeight:bold;fontSize:16px">
        直播卖点
    </div>
    <el-form-item prop="hot_desc" label-width="0">
         <el-input size="small" type="textarea" style="width:100%;" v-model="ruleForm.hot_desc" placeholder="请输入直播卖点"></el-input>
    </el-form-item>
    <!--  -->
    <div class="title" style="marginLeft:5px;marginBottom:20px;fontWeight:bold;fontSize:16px">
        样品相关
    </div>
      <el-form-item label="寄样销量门槛:" prop="sale_condition">
        <el-select style="width: 100%;height: 25px;" size="small" v-model="ruleForm.sale_condition" placeholder="请选择寄样销量门槛">
            <el-option label="无门槛" :value="0"></el-option>
            <el-option label="500以下" :value="1"></el-option>
            <el-option label="1000以下" :value="2"></el-option>
            <el-option label="3000以下" :value="3"></el-option>
            <el-option label="5000以下" :value="4"></el-option>
            <el-option label="10000以下" :value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="寄样粉丝门槛:" prop="fans_condition">
        <el-select style="width: 100%;height: 25px;" size="small" v-model="ruleForm.fans_condition" placeholder="请选择寄样粉丝门槛">
            <el-option label="无门槛" :value="0"></el-option>
            <el-option label="1W以下" :value="1"></el-option>
            <el-option label="5W以下" :value="2"></el-option>
            <el-option label="10W以下" :value="3"></el-option>
            <el-option label="20W以下" :value="4"></el-option>
            <el-option label="50W以下" :value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="购样返费要求:" prop="reback_pay">
         <el-input size="small" v-model="ruleForm.reback_pay" placeholder="请输入购样返费要求"></el-input>
      </el-form-item>
      <div class="title" style="marginLeft:10px;marginBottom:20px;fontWeight:bold;fontSize:16px">
          发货相关
      </div>
      <el-form-item label="发货地点:" prop="send_province">
         <el-input size="small" v-model="ruleForm.send_province" placeholder="请输入发货地点"></el-input>
      </el-form-item>
      <el-form-item label="发货快递:" prop="wlcompany">
         <el-input size="small" v-model="ruleForm.wlcompany" placeholder="请输入发货快递"></el-input>
      </el-form-item>
      <el-form-item label="发货时间:" prop="send_speed">
         <el-select style="width: 100%;height: 25px;" size="small" v-model="ruleForm.send_speed" placeholder="请选择发货时间">
            <el-option label="一天内" :value="1"></el-option>
            <el-option label="两天内" :value="2"></el-option>
            <el-option label="三天内" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="不发货地区:" prop="nosend_area">
         <el-input size="small" v-model="ruleForm.nosend_area" placeholder="请输入不发货地区"></el-input>
      </el-form-item>
      <div class="title" style="marginLeft:10px;marginBottom:20px;fontWeight:bold;fontSize:16px">
          商家实力
      </div>
      <el-form-item label="现有库存:" prop="product_stock">
         <el-input size="small" v-model="ruleForm.product_stock" placeholder="请输入现有库存"></el-input>
      </el-form-item>
      <el-form-item label="日产量:" prop="day_produce">
         <el-select style="width: 100%;height: 25px;" size="small" v-model="ruleForm.day_produce" placeholder="请选择日产量">
            <el-option label="1000以上" :value="1"></el-option>
            <el-option label="5000以上" :value="2"></el-option>
            <el-option label="1W以上" :value="3"></el-option>
            <el-option label="3W以上" :value="4"></el-option>
            <el-option label="5W以上" :value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日发货量:" prop="day_sendnum">
         <el-input size="small" v-model="ruleForm.day_sendnum" placeholder="请输入日发货量"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" style="backgroundColor:#F2F2F5;color:#45474D;borderColor:#FFFFFF" @click="handleClose">取 消</el-button>
        <el-button size="mini" style="backgroundColor:#fe2c55;color:#FFFFFF;borderColor:#FFFFFF" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { editGoods } from '@/api/goods.js'
export default {
  props: {
    editVisible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  watch:{
    editVisible(val){
      if(val){
        // 每次打开重置表单校验
        this.$nextTick(()=>{
          this.$refs['ruleForm'].resetFields();
        })
        for(let key in this.ruleForm){
            this.ruleForm[key] = this.data[key]
        }
      }
    }
  },
  mounted(){
    
  },
  data() {
    return {
        ruleForm: {
          uid:'',
          product_id:'',
          activity_id:'',
          sub_title:'',
          hot_live:'',
          hot_desc:'',
          sale_condition: '',
          fans_condition: '',
          reback_pay: '',
          send_province:'',
          wlcompany:'',
          send_speed:'',
          nosend_area: '',
          product_stock:'',
          day_produce:'',
          day_sendnum:'',
        },
        rules: {
          sub_title: [
            { required: true, message: '请输入商品标题', trigger: 'blur' },
          ],
          hot_live: [
            { required: true, message: '请输入直播利益点', trigger: 'blur' },
          ],
          hot_desc: [
            { required: true, message: '请输入直播卖点', trigger: 'blur' },
          ],
          sale_condition: [
            { required: true, message: '请输入寄样销量门槛', trigger: 'blur' },
          ],
          fans_condition: [
            { required: true, message: '请输入寄样粉丝门槛', trigger: 'blur' },
          ],
          reback_pay:[
            { required: true, message: '请输入购样返费要求', trigger: 'blur' },
          ],
          send_province:[
            { required: true, message: '请输入发货地点', trigger: 'blur' },
          ],
          wlcompany:[
            { required: true, message: '请输入发货快递', trigger: 'blur' },
          ],
          send_speed:[
            { required: true, message: '请输入发货时间', trigger: 'blur' },
          ],
          nosend_area:[
            { required: true, message: '请输入不发货地区', trigger: 'blur' },
          ],
          product_stock:[
            { required: true, message: '请输入现有库存', trigger: 'blur' },
          ],
          day_produce:[
            { required: true, message: '请输入日产量', trigger: 'blur' },
          ],
          day_sendnum:[
            { required: true, message: '请输入日发货量', trigger: 'blur' },
          ],
        }
    };
  },
  methods: {
    // 确认
    handleConfirm(){
      this.$refs['ruleForm'].validate( (valid) => {
        if( valid ){
          editGoods({
            ...this.ruleForm
          }).then( res => {
              if(res.code==800){
                  this.$message.success(res.msg)
                  this.$emit('close','success')
              }else{
                  this.$message.error(res.msg)
              }
          })
        }else{
          console.log('error submit!!');
          this.$message.error('请完整填写!');
          return
        }
      })
    },
    // 关闭close
    handleClose() {
        this.$emit('close','cancel')
    },
  },
};
</script>

<style lang='scss' scoped>
  /deep/::-webkit-scrollbar {
    display: none !important;
  }
  /deep/.el-form-item__label{
      text-align: center;
  }
  /deep/.el-dialog__header{
      border-bottom: solid 1px #E6E7EB;
  }
  .demo-ruleForm{
      height: 600px;
      overflow-y: scroll;
  }
</style>